import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface WeeklySchedule {
    WeeklyPlanName: any;
    id: number;
    fullName: any;
    cookProfileId: number;
    foodMenuItemId: number;
    foodMenuName: string;
    kitchenName: any;
    mealTypeId: number;
    mealTypeName: string;
    packLevel: string;
    packUnit: string;
    priceOverride: number;
    quantityAvailable: number;
    scheduledDate: string;
    deliveryStartTime: string;
    deliveryEndTime: string;
    preorderClosingDatetime: string;
    spiceLevelId: number;
    spiceLevelName: string;
    imageUrl: string;
    specialMention: string | null;
    areaCodes: string[] | null;
    areaCodeNames: string[] | null;
    isActive: boolean;
    auditTrailId: number | null;
    WeeklySchedule: any
}

interface WeeklyScheduleState {
    periodDailySchedule: any;
    periodDaily: any;
    data: WeeklySchedule[];
    loading: boolean;
    error: string | null;
}

const COOKPORT = import.meta.env.VITE_COOK_PORT;
const COOKURL = import.meta.env.VITE_API_COOK_URL;

interface ApiResponse {
    data: {
        data: WeeklySchedule[];
    }
}

export const fetchWeeklySchedule = createAsyncThunk<WeeklySchedule[], void, { rejectValue: string }>(
    'WeeklySchedule/fetchWeeklySchedule',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<ApiResponse>('/get_all_weekly_schedules', COOKPORT, COOKURL);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createWeeklySchedule: any = createAsyncThunk(
    'WeeklySchedule/createWeeklySchedule', async (params: any, thunkAPI) => {
        try {
            const response = await apiService.post('create_weekly_schedule', params, COOKPORT, COOKURL);
            return response
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);
export const createWeeklyScheduleDates: any = createAsyncThunk(
    'WeeklySchedule/createWeeklySchedule', async (params: any, thunkAPI) => {
        try {
            const response = await apiService.post('create_weekly_schedule_dates', params, COOKPORT, COOKURL);
            return response
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const updateWeeklySchedule: any = createAsyncThunk(
    'WeeklySchedule/updateWeeklySchedule',
    async (params: any, thunkAPI) => {
        console.log(params)
        try {
            const response = await apiService.put('update_weekly_schedule', params, COOKPORT, COOKURL);
            return response
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);


export const fetchPeriodDailySchedule = createAsyncThunk<
    WeeklySchedule[],
    { weeklyScheduleId: any },
    { rejectValue: string }
>(
    'WeeklySchedule/fetchPeriodDailySchedule',
    async (params, { rejectWithValue }) => {
        try {
            const config = { params };
            const response = await apiService.get<any>(
                'get_period_daily_schedule',
                COOKPORT,
                COOKURL,
                config
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'An error occurred');
        }
    }
);

export const weeklyScheduleSlice = createSlice({
    name: 'getAllWeeklySchedule',
    initialState: {
        data: [] as WeeklySchedule[],
        loading: false,
        error: null,
    } as WeeklyScheduleState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchWeeklySchedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchWeeklySchedule.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchWeeklySchedule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createWeeklySchedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createWeeklySchedule.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(createWeeklySchedule.rejected, (state, action: PayloadAction<string>) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateWeeklySchedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateWeeklySchedule.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                const updatedTable = action.payload;
            })
            .addCase(updateWeeklySchedule.rejected, (state, action: PayloadAction<string>) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchPeriodDailySchedule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPeriodDailySchedule.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchPeriodDailySchedule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            });

    },
});

export default weeklyScheduleSlice.reducer;